const state = {
  status_modal: {
    show: false,
    application: null,
    applicant_dt_row_data: null
  }
}

const actions = {}

const mutations = {
  SHOW_APPLICANT_STATUS_CHANGE_MODAL(state, payload) {
    state.status_modal.show = true
    state.status_modal.application = payload.application
    state.status_modal.applicant_dt_row_data = payload.applicant_dt_row_data
  },
  HIDE_APPLICANT_STATUS_CHANGE_MODAL(state) {
    state.status_modal.show = false
    state.status_modal.application = null
    state.status_modal.applicant_dt_row_data = null
  }
}

export default {
  state,
  actions,
  mutations
}
